import { getTrustedHTML, SanitizerReturnType } from './getTrustedHTML';

/**
 * Converts HTML string to plain text content.
 * This function safely removes all HTML elements while preserving the text content.
 * Uses getTrustedHTML for secure HTML parsing with Trusted Types support.
 *
 * @param html - The HTML string to convert
 * @param includeLineBreaks - Whether to preserve line breaks from paragraphs
 * @returns The plain text content without HTML tags
 */
export default function convertHtmlToPlainText(
    html: string,
    includeLineBreaks: boolean = false
): string {
    try {
        const htmlElement = getTrustedHTML(html, SanitizerReturnType.HTMLElement);
        const styleElements = htmlElement.querySelectorAll('style');

        if (styleElements && styleElements.length > 0) {
            for (let i = 0; i < styleElements.length; i++) {
                if (styleElements[i]) {
                    /* eslint-disable-next-line @microsoft/sdl/no-inner-html --
                     * The string is empty so it just need to be casted as a TrustedHTML object.
                     */
                    styleElements[i].innerHTML = getTrustedHTML('', SanitizerReturnType.String);
                }
            }
        }

        // To return the plain text content with line break characters added (\r\n) to indicate end of paragraphs and manually added line breaks.
        if (includeLineBreaks) {
            const proofElements = [
                ...htmlElement.getElementsByClassName('x_elementToProof'),
                ...htmlElement.getElementsByClassName('elementToProof'),
            ];
            if (proofElements && proofElements.length > 0) {
                for (let i = 0; i < proofElements.length - 1; i++) {
                    proofElements[i].textContent = proofElements[i].textContent + '\r\n';
                    if (
                        proofElements[i].innerHTML === '<br>' ||
                        proofElements[i].innerHTML === '<br/>'
                    ) {
                        proofElements[i].textContent = '\r\n';
                    }
                }
            }
        }
        return htmlElement.textContent || '';
    } catch {
        return '';
    }
}
